import { APP_INITIALIZER, NgModule } from '@angular/core';
import { ensureSession, UB_CLIENT } from '@unleashed/api/common';
import { AppComponent } from './app.component';
import { EcommerceModule } from '@unleashed/ecommerce/ecommerce.module';
import { environment } from 'src/environments/environment';
import { NoopGoogleTagManagerService } from '@unleashed/services/common/noop-google-tag-manager.service';
import { GoogleTagManagerService } from 'angular-google-tag-manager';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    EcommerceModule
  ],
  providers: [
    { provide: UB_CLIENT, useValue: 'booking-ua' },
    { provide: APP_INITIALIZER, multi: true, useValue: () => ensureSession(environment.unleashedApiUrl, 'booking-ua') },
    {
      provide: GoogleTagManagerService,
      useClass: (environment.production || environment.stage)
        ? GoogleTagManagerService
        : NoopGoogleTagManagerService
    },
    ...((environment.production || environment.stage)
      ? [{ provide: 'googleTagManagerId', useValue: environment.googleTagManager.id }]
      : [])
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
